import { render, staticRenderFns } from "./Reset.vue?vue&type=template&id=46155f66"
import script from "./Reset.vue?vue&type=script&lang=js"
export * from "./Reset.vue?vue&type=script&lang=js"
import style0 from "@/vendor/styles/pages/authentication.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "./Reset.vue?vue&type=style&index=1&id=46155f66&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports